export * from '@sportworld/js-sdk/src/constants/paths'

import { focusIds } from '@/constants/focus'

export const paths = {
  ROOT: '/',
  INDEX: '/index.html',
  EMPTY: '/empty',
  CLASSIC_HOME: `/${focusIds.CLASSIC_HOME}`,
  HOME: `/${focusIds.HOME}`,
  SPECIAL_HOME: `/${focusIds.SPECIAL_HOME}`,
  SPORTS: `/${focusIds.SPORTS}`,
  CATALOGUE: `/${focusIds.CATALOGUE}`,
  FAVORITES: `/${focusIds.FAVORITES}`,
  CALENDAR: `/${focusIds.CALENDAR}`,
  SUBSCRIPTIONS: `/${focusIds.SUBSCRIPTIONS}`,
  OFFERS: `/${focusIds.OFFERS}`,
  SETTINGS: `/${focusIds.SETTINGS}`,
  SETTINGS_SUBSCRIPTIONS: focusIds.SETTINGS_SUBSCRIPTIONS,
  SETTINGS_ACCOUNT: focusIds.SETTINGS_ACCOUNT,
  SETTINGS_IMPRINT: focusIds.SETTINGS_IMPRINT,
  SETTINGS_DATA_PRIVACY: focusIds.SETTINGS_DATA_PRIVACY,
  SETTINGS_TERMS_CONDITIONS: focusIds.SETTINGS_TERMS_CONDITIONS,
  SETTINGS_DEVELOPER: `${focusIds.SETTINGS_DEVELOPER}`,
  SETTINGS_SMART_PREVIEW: `${focusIds.SETTINGS_SMART_PREVIEW}`,
  SETTINGS_REGION: `${focusIds.SETTINGS_REGION}`,
  SETTINGS_COOKIE_BANNER: `${focusIds.USERCENTRICS}`,
  EVENT_PAGE: `/${focusIds.EVENT_PAGE}`,
  PAGE: `/${focusIds.PAGE}`,
  SELECTED_PAGE: `/${focusIds.SELECTED_PAGE}`,
  MEDIA_PLAYER: `/media/player`,
  LOGIN: `/${focusIds.LOGIN}`,
  REGISTER: `/${focusIds.REGISTER}`,
  CHECKOUT: `/${focusIds.CHECKOUT}`,
  SELF_SERVICE: `/${focusIds.SELF_SERVICE}`,
  FEATURE_SCREEN: `/${focusIds.FEATURE_SCREEN}`,
  ERROR: `/${focusIds.ERROR}`,
  LOGOUT: `/${focusIds.LOGOUT}`,
  EXIT: `/${focusIds.EXIT}`,
  HOME_GRID: `/${focusIds.HOME_GRID}`,
  LIST: `/${focusIds.LIST}`,
  SEARCH: `/${focusIds.SEARCH}`,
  FOCUS_PAGE: `/${focusIds.FOCUS_PAGE}`,
  NOT_FOUND: '*',
  SETTINGS_HLS_ADS_PLAYER: focusIds.SETTINGS_HLS_ADS_PLAYER,
}

export const mainPaths = [
  paths.SPECIAL_HOME,
  paths.HOME,
  paths.CLASSIC_HOME,
  paths.HOME_GRID,
  paths.SELECTED_PAGE,
  paths.FAVORITES,
  paths.SPORTS,
  paths.PAGE,
  paths.CALENDAR,
  paths.EMPTY,
  paths.SEARCH,
]
